export const SpinnerPage =
`<!DOCTYPE html>
<html>
<head>
  <style>
    .spinner{
      box-sizing: border-box;
      position: absolute;
      left: 50%;
      top: 50%;
      height: 100px;
      margin-left: -50px;
      margin-top: -50px;
      width: 100px;
      -webkit-animation: rotation .7s infinite linear;
      -moz-animation: rotation .7s infinite linear;
      -o-animation: rotation .7s infinite linear;
      animation: rotation .7s infinite linear;
      border-left: 5px solid hsla(0,0%,59%,.3);
      border-right: 5px solid hsla(0,0%,59%,.3);
      border-bottom: 5px solid hsla(0,0%,59%,.3);
      border-top: 5px solid hsla(0,0%,59%,.9);
      border-radius: 100%;
    }

    @-webkit-keyframes rotation {
   from {-webkit-transform: rotate(0deg);}
   to {-webkit-transform: rotate(359deg);}
  }

  @-moz-keyframes rotation {
   from {-moz-transform: rotate(0deg);}
   to {-moz-transform: rotate(359deg);}
  }

  @-o-keyframes rotation {
   from {-o-transform: rotate(0deg);}
   to {-o-transform: rotate(359deg);}
  }

  @keyframes rotation {
   from {transform: rotate(0deg);}
   to {transform: rotate(359deg);}
  }
  </style>
  <title></title>
</head>
<body>
  <div class="spinner"></div>
</body>
</html>`;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/spinner/spinner-page.js
 **/